import { TenantDomainId } from '../../../../../../store/features/pageConfig';

export interface EventSeriesLink {
  id: string;
  name: string;
  href: string;
}

export interface DataCenterWorldFooterConfig {
  title: string;
  subtitle: string;
  dates: string;
  venue: string;
  location: string;
  homeHref: string;
  contactHref: string;
  termsHref: string;
}

const DATACENTERWORLD_URL = 'https://datacenterworld.com/';
const DCWPOWER_URL = 'https://dcwpower.com/';

// Canonical, ordered list of every event in the Data Center World global
// series. Each tenant's own footer excludes itself from this list - see
// `getEventSeriesLinks` in DataCenterWorldFooter.tsx.
export const GLOBAL_EVENT_SERIES: EventSeriesLink[] = [
  {
    id: TenantDomainId.DATACENTERWORLD,
    name: 'Data Center World',
    href: DATACENTERWORLD_URL,
  },
  {
    id: TenantDomainId.DCWPOWER,
    name: 'Data Center World Power',
    href: DCWPOWER_URL,
  },
  {
    id: 'EUROPE',
    name: 'Data Center World Europe',
    href: 'https://datacenterworldeurope.com/',
  },
  {
    id: 'AUSTRALIA',
    name: 'Data Center World Australia',
    href: 'https://datacenterworldaustralia.com/',
  },
  {
    id: 'HONGKONG',
    name: 'Data Center World Hong Kong',
    href: 'https://www.datacenter-asia.com/hongkong/',
  },
  {
    id: 'JAKARTA',
    name: 'Data Center World Jakarta',
    href: 'https://www.datacenter-asia.com/jakarta/',
  },
  {
    id: 'BRASIL',
    name: 'Data Center World Brasil',
    href: 'https://datacenterworldbrasil.com.br/en/',
  },
  {
    id: 'MIDDLEEAST',
    name: 'Data Center World Middle East',
    href: 'https://www.datacenterworldmiddleeast.com/',
  },
];

export const contentConfig: Partial<
  Record<TenantDomainId, DataCenterWorldFooterConfig>
> = {
  [TenantDomainId.DATACENTERWORLD]: {
    title: 'Data Center World',
    subtitle: 'Empowering Innovation at Scale',
    dates: 'May 24 - 27, 2027',
    venue: 'Music City Center',
    location: 'Nashville, TN',
    homeHref: DATACENTERWORLD_URL,
    contactHref: 'https://datacenterworld.com/contact-us/',
    termsHref: 'https://datacenterworld.com/terms-and-conditions/',
  },
  [TenantDomainId.DCWPOWER]: {
    title: 'Data Center World Power',
    subtitle: 'Powering the Digital Ecosystem',
    dates: 'Sept 21 - Sept 23, 2026',
    venue: 'Gaylord Texan Resort & Convention Center',
    location: 'Dallas, TX',
    homeHref: DCWPOWER_URL,
    contactHref: 'https://dcwpower.com/contact-us/',
    termsHref: 'https://dcwpower.com/terms-and-conditions/',
  },
};

export const PRIVACY_POLICY_LINK = 'https://www.informa.com/privacy-policy/';

export const CCPA_LINK =
  'https://privacyportal-eu-cdn.onetrust.com/dsarwebform/c1f53e84-9f05-4169-a854-85052b63c50b/5f26b553-52cc-4973-a761-295d5634a6b6.html';
